// 9fbef606107a605d69c0edbcd8029e5d

export const DAY_VARIANTS = {
  TODAY: "today",
  SELECTED: "selected",
  START: "start",
  END: "end",
  BETWEEN: "between",
};
